<template>
    <el-dialog :title="title" :width="pageType == 'page' ? '72%':'60%'" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :inline="true" :model="form" ref="form" label-width="140px" v-loading="loading"
                 :disabled="method==='view'"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-form-item label="功能名称：">{{form.detailName}}</el-form-item>
            <el-form-item label="图标：">
                <span :class="[form.detailIcon]"></span>
            </el-form-item>
            <el-form-item label="启用状态：" prop="disabled">
                <el-switch v-model="form.disabled" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
            <div class="title">{{pageType == 'page' ? '操作' : '隐藏'}}条件设置</div>
            <div v-for="(item, index) in form.metadataTableConfigPageWhereList" :key="index">
                <el-form-item :prop="`metadataTableConfigPageWhereList[${index}].conditionApproach`" label-width="0px">
                    <el-select v-model="item.conditionApproach" placeholder="请选择" class="methodSel">
                        <el-option v-for="(e, i) in $dictUtils.getDictList('conditionApproach')" :key="i"
                                   :label="e.label"
                                   :value="e.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                        :prop="`metadataTableConfigPageWhereList[${index}].basicDataDetailId`"
                        :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]"
                        label-width="10px">
                    <el-select v-model="item.basicDataDetailId" placeholder="请选择" filterable
                               @change="archivesChange(item)">
                        <el-option v-for="c in config" :key="c.basicDataDetailId" :label="c.basicRename"
                                   :value="c.basicDataDetailId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                        :prop="`metadataTableConfigPageWhereList[${index}].condition`"
                        :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]" label-width="10px">
                    <el-select v-model="item.condition" placeholder="请选择" @change="conditionChange(item)">
                        <el-option
                                :key="v.value"
                                :label="v.label"
                                :value="v.value"
                                v-for="v in getMethodCode(item)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                        :prop="`metadataTableConfigPageWhereList[${index}].whereDetail`"
                        :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}, validatorDataRule(item)]"
                        v-if="item.condition && item.condition != '=null' && item.condition != '!=null'"
                        label-width="10px">
                    <!--单行文本、多行文本-->
                    <el-input v-model.trim="item.whereDetail" placeholder="请输入" :maxlength="item.basicAssemblyId == '1' ? 200 : 2000" clearable
                              :rows="1" :type="item.basicAssemblyId == '2' ? 'textarea' : ''"
                              v-if="item.basicAssemblyId == '1' || item.basicAssemblyId == '2'"></el-input>
                    <!--数字-->
                    <el-input v-model.trim="item.whereDetail" placeholder="请输入" clearable maxlength="19"
                              @input="(v)=>(item.whereDetail=v.replace(/[^\d-.]/g,''))" v-if="item.basicAssemblyId == 12"></el-input>
                    <!--下拉单选、单选框组、下拉多选、多选框组-->
                    <el-select v-model="item.whereDetail"
                               :multiple="item.basicAssemblyId == 6 || item.basicAssemblyId == 7"
                               placeholder="请选择" clearable
                               v-if="item.basicAssemblyId == 4 || item.basicAssemblyId == 5 || item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 10">
                        <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                   :label="v.basicRange"
                                   :value="v.metadataRangeId"></el-option>
                    </el-select>
                    <!--时间-->
                    <el-time-picker v-model="item.whereDetail" placeholder="请选择"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                    clearable v-if="item.basicAssemblyId == 8"></el-time-picker>
                    <!--日期-->
                    <el-date-picker class="w100i"
                                    v-model="item.whereDetail" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                    :type="setDatePickerType(item)"
                                    clearable placeholder="请选择"
                                    v-if="item.basicAssemblyId == 9"></el-date-picker>
                </el-form-item>
                <el-form-item :prop="`metadataTableConfigPageWhereList[${index}].promptMessage`" label-width="10px" v-if="pageType == 'page'">
                    <el-input v-model.trim="item.promptMessage" placeholder="请输入提示语" maxlength="200" clearable></el-input>
                </el-form-item>
                <el-link icon="el-icon-delete" class="m_t1" type="danger" :underline="false" @click="del(index)"
                         v-if="method != 'view'"></el-link>
            </div>
            <el-button type="text" class="addCondition" @click="addCondition()" v-if="method != 'view'">+
                添加设置
            </el-button>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{ method == 'view' ? '关闭' : '取消' }}</el-button>
            <el-button size="small" type="primary" :disabled="loading" v-if="method != 'view'" @click="doSubmit()"
                       v-noMoreClick>保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                pageType: '',
                form: {
                    metadataFonctionsModelDetailId: "",
                    detailName: "",
                    detailIcon: "",
                    disabled: "",
                    metadataTableConfigPageWhereList: [],
                },
                config: {},
            }
        },
        methods: {
            // 初始化数据  config元数据配置
            init(row, method, pageType, config) {
                this.method = method
                this.config = config
                this.pageType = pageType
                if (pageType == 'page') {
                    this.title = '页面功能'
                } else if (pageType == 'list') {
                    this.title = '列表功能'
                } else if (pageType == 'from') {
                    this.title = '表单功能'
                } else if (pageType == 'style') {
                    this.title = '整列特定样式'
                }
                if (method === 'edit') {
                    this.title = '修改' + this.title
                } else if (method === 'view') {
                    this.title = '查看' + this.title
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.form = this.recover(this.form, row);
                    if (row.metadataTableConfigPageWhereList) {
                        this.form.metadataTableConfigPageWhereList = JSON.parse(JSON.stringify(row.metadataTableConfigPageWhereList))
                    } else {
                        this.form.metadataTableConfigPageWhereList = []
                    }
                    this.form.metadataTableConfigPageWhereList.map(item => {
                        this.archivesChange(item, 1)
                    })
                })
            },
            // 选择元数据字段
            archivesChange(item, type) {
                let val = this.config.filter(v => v.basicDataDetailId == item.basicDataDetailId)[0]
                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(item, 'basicCode', val.basicCode)
                this.$set(item, 'basicRangeList', val.basicRangeList)
                this.$set(item, 'metadataBasicDataRuleVo', val.metadataBasicDataRuleVo)
                this.$set(item, 'basicRename', val.basicRename)
                if (!type) {
                    if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7) {
                        this.$set(item, 'whereDetail', [])
                    } else {
                        this.$set(item, 'whereDetail', '')
                    }
                } else {
                    if (item.basicAssemblyId != 6 && item.basicAssemblyId != 7) {
                        this.$set(item, 'whereDetail', item.whereDetail[0])
                    }
                }
            },
            // 选择条件
            conditionChange(item) {
                if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7) {
                    this.$set(item, 'whereDetail', [])
                } else {
                    this.$set(item, 'whereDetail', '')
                }
            },
            // 添加筛选条件
            addCondition() {
                this.form.metadataTableConfigPageWhereList.push({
                    conditionApproach: 'and',
                    basicDataDetailId: "",
                    condition: "",
                    whereDetail: '',
                    promptMessage: '',
                })
            },
            // 删除筛选条件
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.metadataTableConfigPageWhereList.splice(index, 1);
                })
            },
            // 获取条件字典
            getMethodCode(item) {
                let condition = this.$dictUtils.getDictList('condition')
                let opt = condition.filter(v => v.value != '>=' && v.value != '<=')
                if(item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12') {
                    opt = condition.filter(v => v.value != '%' && v.value != '!%')
                }
                return opt
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let p = JSON.parse(JSON.stringify(this.form))
                        p.metadataTableConfigPageWhereList.map(item => {
                            if (item.basicAssemblyId != 6 && item.basicAssemblyId != 7) {
                                item.whereDetail = item.whereDetail.split(',')
                            }
                        })
                        this.$emit("getInfo", {form: p, pageType: this.pageType})
                        this.visible = false
                    }
                })
            },
        }
    }
</script>
<style scoped lang="scss">
    .title {
        font-size: 14px;
        color: #000;
        margin: 10px 0 20px;
        font-weight: bold;
    }

    .methodSel {
        width: 80px !important;
    }
</style>
